import { CalendarDesktop } from './CalendarDesktop';
import { CalendarMobile } from './CalendarMobile';
import type { CalendarViewEvent } from 'gossamer-front-end';
import type { BookingExtendedViewRow } from 'cb-model';
import { useIsMobile } from '../event/hooks/useIsMobile';

export interface UserBookingCalendarEvent extends CalendarViewEvent {
  bgColor: string;
  textColor: string;
  booking?: BookingExtendedViewRow;
}

export const CalendarCombined = (): React.JSX.Element => {
  const isMobile = useIsMobile(992); // Bootstrap's `lg` breakpoint
  return isMobile ? <CalendarMobile /> : <CalendarDesktop />;
};
